var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"agency-predictions-container"}},[_c('div',{staticClass:"left-hand-side"},[_c('nav-agency-header'),_vm._v(" "),_c('nav-controls',{attrs:{"isLargeScreen":_vm.isLargeScreen}}),_vm._v(" "),_c('nav-footer')],1),_vm._v(" "),(_vm.isLargeScreen)?_c('leaflet-map'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }